import Loadable from 'react-loadable';
import Loading from 'components/util/loading/Loading';

const KindergartenMath = Loadable(
    {
        loader: () => import('./routes'),
        loading: Loading,
    });

export default KindergartenMath; 